import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './RedeemPointAction.module.sass';
import closeIcon from '../../../../../images/icons/close-bold.svg';
import Button from '../../../../ui_kit/button/Button';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import { userObjectSelector } from '../../../../user/selectors/user';
import api from '../../../api';
import { loyaltyProgramActions } from '../../../actions';
import scrollToElement from '../../../../services/smooth_scroll';
import { userActions } from '../../../../user/actions';

function RedeemPointAction(props) {
  const {
    action, clicked, setClicked, code, setCode, loading, setLoading,
    user, setPointMovements, setPointsEarnedForYear, setUser,
    setPointBalance,
  } = props;
  const {
    image, name, amount, id,
  } = action;

  const codeRef = useRef(null);
  const [copied, setCopied] = useState(false);

  return (
    <div className={styles.action}>
      <div className={styles.image}>
        <img src={image} alt={name} />
        { (user || code) && (
          <>
            { !clicked && (
              <ClickableDiv className={styles.clickable} onClick={() => setClicked(true)} />
            )}
            { clicked && (
              <>
                <ClickableDiv
                  className={styles.close}
                  onClick={() => {
                    setClicked(false);
                  }}
                >
                  <img src={closeIcon} alt="close" />
                </ClickableDiv>
                <div className={styles.content}>
                  { !code && (
                    <>
                      <div className={styles.text}>
                        { user && user.point_balance >= amount && !user.loyalty_program_deactivated_at && (`Spend ${amount} points?`) }
                        { !(user && user.point_balance >= amount) && !user.loyalty_program_deactivated_at && 'Not enough points to redeem' }
                        { user && user.loyalty_program_deactivated_at && 'To redeem points, opt-in to The Lounge' }
                      </div>
                      { user && user.point_balance >= amount
                        && !user.loyalty_program_deactivated_at && (
                        <>
                          <Button
                            className={styles.button}
                            onClickHandler={() => {
                              setLoading(true);
                              api.redeem(id).then((response) => {
                                const {
                                  point_movements: newPointMovements,
                                  points_earned_for_year: newPointsEarnedForYear,
                                  point_balance: newPointBalance,
                                  code: newCode,
                                } = response.data;
                                setPointMovements(newPointMovements);
                                setPointsEarnedForYear(newPointsEarnedForYear);
                                setPointBalance(newPointBalance);
                                if (newCode) {
                                  setCode(newCode);
                                }
                                setLoading(false);
                              });
                            }}
                            loading={loading}
                          >
                            YES
                          </Button>
                          <small>
                            This action is not reversible
                          </small>
                        </>
                      )}
                      { !(user && user.point_balance >= amount)
                        && !user.loyalty_program_deactivated_at && (
                        <Button
                          className={styles.button}
                          onClickHandler={() => {
                            scrollToElement('get-involved');
                          }}
                        >
                          EARN MORE
                        </Button>
                      )}
                      { user && user.loyalty_program_deactivated_at && (
                        <Button
                          className={styles.button}
                          onClickHandler={() => {
                            setLoading(true);
                            api.reactivateLoyaltyProgram().then((response) => {
                              setUser(response.data);
                              setLoading(false);
                            });
                          }}
                          color="yellow"
                          loading={loading}
                        >
                          JOIN NOW
                        </Button>
                      )}
                    </>
                  )}
                  { code && (
                    <>
                      <div className={`${styles.text} ${styles.code}`}>
                        CODE:
                        <br />
                        {code}
                      </div>
                      <ClickableDiv
                        className={styles.button}
                        onClick={() => {
                          codeRef.current.select();
                          document.execCommand('copy');
                          setCopied(true);
                        }}
                      >
                        { copied ? 'COPIED' : 'COPY'}
                      </ClickableDiv>
                    </>
                  )}
                </div>
                <input
                  type="text"
                  readOnly
                  style={{ position: 'absolute', left: '-99999px' }}
                  ref={codeRef}
                  value={code || ''}
                />
              </>
            )}
          </>
        )}
      </div>
      <div className={styles.name}>
        {name}
      </div>
      <div className={styles.amount}>
        {`${amount} Points`}
      </div>
    </div>
  );
}

RedeemPointAction.propTypes = {
  action: PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  clicked: PropTypes.bool.isRequired,
  setClicked: PropTypes.func.isRequired,
  code: PropTypes.string,
  setCode: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
  user: PropTypes.shape({
    point_balance: PropTypes.number,
    loyalty_program_deactivated_at: PropTypes.string,
  }),
  setPointBalance: PropTypes.func.isRequired,
  setPointMovements: PropTypes.func.isRequired,
  setPointsEarnedForYear: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setPointMovements: (pointMovements) => dispatch(
    loyaltyProgramActions.setPointMovements(pointMovements),
  ),
  setPointsEarnedForYear: (pointsEarnedForYear) => dispatch(
    loyaltyProgramActions.setPointsEarnedForYear(pointsEarnedForYear),
  ),
  setPointBalance: (pointBalance) => dispatch(
    loyaltyProgramActions.setPointBalance(pointBalance),
  ),
  setUser: (user) => dispatch(userActions.setUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RedeemPointAction);
